import routerOptions0 from "/var/jenkins_home/workspace/hn-wy-website/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}